module.exports = __webpack_public_path__ + "static/4-designer-life-b508550ca6224060788dff8f4873220e.svg";